import { motion } from "framer-motion";
import { CircleAlert, X } from "lucide-react";

interface ChannelWarningNotificationProps {
  message: string;
  onClose: () => void;
}

const ChannelWarningNotification = ({
  message,
  onClose,
}: ChannelWarningNotificationProps) => (
  <motion.div
    role="alert"
    initial={{ opacity: 0, y: -20, scale: 0.95 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
    className="pointer-events-auto flex w-max max-w-[min(560px,calc(100vw-32px))] items-center gap-3.5 rounded-[20px] border border-[#F59E0B]/20 bg-[#FFF0CF] py-3 pl-5 pr-3 text-[#171717] shadow-[0_4px_14px_rgba(146,102,20,0.16)]"
    style={{ fontFamily: 'Mulish, "Segoe UI", system-ui, sans-serif' }}
  >
    <CircleAlert
      aria-hidden="true"
      size={22}
      color="#F59E0B"
      strokeWidth={2.4}
      className="shrink-0"
    />
    <span className="flex-1 text-base font-bold leading-[1.35]">{message}</span>
    <button
      type="button"
      aria-label="Dismiss warning"
      onClick={onClose}
      className="flex shrink-0 items-center justify-center rounded-[12px] text-[#5A4318] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F59E0B]/50"
    >
      <span className="flex h-[34px] w-[34px] items-center justify-center rounded-[12px] bg-[#F59E0B]/25 transition-colors hover:bg-[#F59E0B]/40">
        <X size={18} strokeWidth={2.5} />
      </span>
    </button>
  </motion.div>
);

export default ChannelWarningNotification;
